import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface Slide0Props {
  isDark?: boolean;
}
export function Slide0({
  isDark = false
}: Slide0Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const mascotVariants = {
    hidden: {
      opacity: 0,
      scale: 0.9,
      x: 20
    },
    visible: {
      opacity: 1,
      scale: 1,
      x: 0,
      transition: {
        duration: 1,
        ease: [0.25, 0.1, 0.25, 1],
        delay: 0.5
      }
    }
  };
  // Different mascot images for light and dark modes
  const lightModeMascot = 'https://cdn.magicpatterns.com/uploads/hsHWFNUKqS3eG496cEpPa5/About_Us_Page_Illustration_1.png';
  const darkModeMascot = 'https://cdn.magicpatterns.com/uploads/5SmW1QpWooryTux9f4meUP/Heliona_Mascot.svg';
  // Different logo images for light and dark modes
  const lightModeLogo = 'https://cdn.magicpatterns.com/uploads/gsWfp7Yqa2Z6SBgP3SbdyL/HELIONA_transparent.png';
  const darkModeLogo = 'https://cdn.magicpatterns.com/uploads/siQDa69uZkA61S2PiBLFML/Heliona_Logo_-_Dark.png';
  return <div className="h-full flex items-center max-w-7xl mx-auto px-6 sm:px-12 py-16 sm:py-24" data-id="element-716">
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-717">
        {/* Left Column - Content */}
        <motion.div className="flex flex-col justify-center text-center lg:text-left" variants={containerVariants} initial="hidden" animate="visible" data-id="element-718">
          {/* Logo */}
          <motion.div variants={itemVariants} className="mb-8 sm:mb-10 lg:mx-0 mx-auto" data-id="element-719">
            <img src={isDark ? darkModeLogo : lightModeLogo} alt="Heliona Logo" className="h-12 sm:h-16" data-id="element-720" />
          </motion.div>

          {/* Tagline */}
          <motion.div variants={itemVariants} className={`mb-10 sm:mb-14 inline-flex px-5 sm:px-7 py-2.5 rounded-full lg:self-start self-center backdrop-blur-sm shadow-sm ${isDark ? 'bg-heliona-mint/10 border border-heliona-mint/30' : 'bg-heliona-mint/10 border border-heliona-mint/30'}`} data-id="element-721">
            <span className={`font-semibold text-xs sm:text-sm tracking-wider uppercase ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-722">
              A Leadership Risk Reduction System
            </span>
          </motion.div>

          {/* Main Title */}
          <motion.h1 variants={itemVariants} className={`text-4xl sm:text-6xl font-serif font-medium mb-6 sm:mb-8 leading-[1.1] ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-723">
            Leadership wellness.
            <br data-id="element-724" />
            <span className={`italic ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-725">
              Culture clarity you can measure.
            </span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p variants={itemVariants} className={`text-lg sm:text-2xl mb-12 sm:mb-20 max-w-2xl leading-relaxed lg:mx-0 mx-auto ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-726">
            The business case for investing in people leader capacity, clarity,
            and resilience
          </motion.p>

          {/* Decorative Element */}
          <motion.div variants={itemVariants} className={`text-sm sm:text-base lg:text-left text-center ${isDark ? 'text-white/60' : 'text-heliona-text-gray/60'}`} data-id="element-727">
            Press → to begin
          </motion.div>
        </motion.div>

        {/* Right Column - Mascot */}
        <motion.div className="hidden lg:flex items-center justify-center" variants={mascotVariants} initial="hidden" animate="visible" data-id="element-728">
          <div className="relative" data-id="element-729">
            {/* Dark gradient/shadow - only in light theme */}
            {!isDark && <div className="absolute inset-0 bg-gradient-to-br from-heliona-navy/10 via-heliona-slate/5 to-transparent rounded-full blur-3xl" data-id="element-730"></div>}
            {/* Mint glow - only in dark theme */}
            {isDark && <div className="absolute inset-0 bg-heliona-mint/10 rounded-full blur-3xl" data-id="element-731"></div>}
            <img src={isDark ? darkModeMascot : lightModeMascot} alt="Heliona Mascot" className="relative w-full max-w-lg h-auto" data-id="element-732" />
          </div>
        </motion.div>
      </div>
    </div>;
}